import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
}
const Card: React.FC<CardProps> = ({
  children,
  className = ''
}) => {
  return <div className={`bg-[#111827] border border-gray-800 rounded-lg overflow-hidden shadow-md ${className}`} data-id="element-27">
      {children}
    </div>;
};
export default Card;